
















// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBasePiscine from '@/components/administration/piscine/edit/EditBasePiscine.vue'
import * as rules from '@/utils/validationRules'
import AddressEdit from '@/components/administration/address/AddressEdit.vue'    
import { AloPiscine, getDefaultAloPiscine } from '@/models/alo/AloPiscine'
import { LatLng, latLng } from 'leaflet'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'

@Component({
  name: 'EditAdresse',    
  components:{EditBasePiscine,AddressEdit, 
    LMap,
    LTileLayer,
    LMarker   
  }
})
export default class EditAdresse extends Vue {
      
  private piscine:AloPiscine = getDefaultAloPiscine()

  private zoom = 10  
  private url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
  private attribution ='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
  private defaultPos = latLng(43.143089, 6.024514)    
  private center = [43.143089,6.024514]

  edit(item:AloPiscine) {        
    this.piscine = (this.$refs.baseEdit as EditBasePiscine).edit(item)    
    this.center = [this.posGps.lat,this.posGps.lng]
  }
  

  get configuration(){
    return this.$store.myGetters.configuration
  }
  
  private get editorConfig(){
    return {...this.configuration.editorDefaultConfig,height:350}
  }  

  get hasPosGps(){
    return this?.piscine?.address?.gpsLat && this?.piscine?.address?.gpsLon
  }
  get posGps(){
    return this.hasPosGps? latLng(this.piscine.address.gpsLat!,this.piscine.address.gpsLon!) : this.defaultPos
  }
 
 
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }  

  updateLatLng(pos:LatLng){    
    this.piscine.address = {...this.piscine.address,gpsLat:pos.lat,gpsLon:pos.lng}
  }
      
}
